import * as React from 'react';
import * as styles from './styles.css';
import { DropdownList } from './DropdownList';
import { Dropdown } from '../Dropdown';
import { DropdownFilterButton } from '../DropdownFilterButton';
/**
 * Визуальный компонент рендерит фильтр с открывающимся дропдауном - списком
 * Переиспользуемый для строки фильтров на десктопе. Не для мобайла
 * */

import { jsx as _jsx } from "react/jsx-runtime";
export function FilterWithDropdownList(props) {
  var value = props.value,
      placeholder = props.placeholder,
      _onValueChange = props.onValueChange,
      className = props.className,
      values = props.values,
      isLastFilter = props.isLastFilter,
      isFirstFilter = props.isFirstFilter,
      testId = props.testId,
      errorMessage = props.errorMessage;
  /**
   * Здесь вычисляется лейбл, который будет отрисован на закрытом дропдауне (т.е на кнопке)
   * Если есть активный элемент, то лейбл возьмется из него. Иначе - будет дефолтный плейсхолдер
   *  */

  var label = React.useMemo(function () {
    if (value == null) {
      return placeholder;
    }

    var activeItem = values.find(function (v) {
      return v.value === value;
    });
    return activeItem ? activeItem.label : placeholder;
  }, [placeholder, value, values]);
  return /*#__PURE__*/_jsx(Dropdown, {
    errorMessage: errorMessage,
    testId: "".concat(testId, "_dropdown"),
    classes: {
      root: className,
      dropdown: styles['dropdown']
    },
    master: function master(_ref) {
      var isOpen = _ref.isOpen,
          handleToggle = _ref.handleToggle;
      return /*#__PURE__*/_jsx(DropdownFilterButton, {
        label: label,
        handleToggle: handleToggle,
        isEmpty: value == null,
        isActive: isOpen,
        isFirstFilter: isFirstFilter,
        isLastFilter: isLastFilter,
        testId: testId
      });
    },
    render: function render(_ref2) {
      var handleClose = _ref2.handleClose;
      return /*#__PURE__*/_jsx(DropdownList, {
        value: value,
        values: values,
        onValueChange: function onValueChange(val) {
          _onValueChange(val);

          handleClose();
        }
      });
    }
  });
}